export const industriesMap = {
    "Aerospace & Defence": {
        code: "aerospace_and_defence",
        domains: {
            "Marine/Others": "marine",
            "Aviation": "aviation",
            "Airport Systems": "airport_systems",
            "Unmanned Systems": "unmanned_systems",
            "Defence Platforms & Systems": "defence_platforms_and_systems",
            "CNS Systems": "cns_systems",
            "Electronic Warfare": "electronic_warfare",
            "Simulation & Training": "simulation_and_training",
            "Space": "space",
            "Homeland Security": "homeland_security"
        }
    },
    "Agriculture": {
        code: "agriculture",
        domains: {
            "Seeds & Others": "seeds_and_others",
            "Feed & Animal Nutrition": "feed_and_animal_nutrition",
            "Agrochemicals": "agrochemicals",
            "Agricultural Biologicals": "agricultural_biologicals",
            "Farm Equipment & Irrigation": "farm_equipment_and_irrigation",
            "Precision Agriculture": "precision_agriculture",
            "Testing & Services": "testing_and_services"
        }
    },
    "Automotive & Transportation": {
        code: "automotive_and_transportation",
        domains: {
            "Automotive Materials": "automotive_materials",
            "Logistics & Transportation": "logistics_and_transportation",
            "Driving Support/Security": "driving_support_security",
            "Automotive Systems": "automotive_systems",
            "Automotive Electronics & Electrical Equipment": "automotive_electronics_and_electrical_equipment",
            "Automotive Advance Technologies": "automotive_advance_technologies",
            "Body/Exterior/Interior": "body_exterior_interior",
            "On-Highway/Off-Highway Vehicles": "on_highway_off_highway_vehicles",
            "Engine/Engine System/Exhaust": "engine_engine_system_exhaust",
            "Electric/Hybrid Vehicles": "electric_hybrid_vehicles",
            "Locomotives & Rolling Stock": "locomotives_and_rolling_stock",
            "Semi-Autonomous & Autonomous Vehicle": "semi_autonomous_and_autonomous_vehicle",
            "Telematics & Infotainment": "telematics_and_infotainment",
            "Connected Car": "connected_car"
        }
    },
    "Banking, Financial Services & Insurance": {
        code: "banking_financial_services_and_insurance",
        domains: {
            "Fintech": "fintech",
            "Payments": "payments",
            "BFSI Security": "bfsi_security",
            "Banking": "banking",
            "Insurance": "insurance"
        }
    },
    "Chemicals & Material": {
        code: "chemicals_and_material",
        domains: {
            "Green Bio-Chemicals": "green_bio_chemicals",
            "Equipment Machine & Tooling": "equipment_machine_and_tooling",
            "Membranes": "membranes",
            "Yarns Fabric & Textile": "yarns_fabric_and_textile",
            "Foam & Insulation": "foam_and_insulation",
            "Resins & Polymers": "resins_and_polymers",
            "Fibers & Composites": "fibers_and_composites",
            "Ceramics & Glass": "ceramics_and_glass",
            "Water Purification": "water_purification",
            "Renewable Energy Material": "renewable_energy_material",
            "Infrastructure Material": "infrastructure_material",
            "Industrial Gases": "industrial_gases",
            "Packaging Material": "packaging_material",
            "Food & Beverage Material": "food_and_beverage_material",
            "Bulk Chemicals": "bulk_chemicals"
        }
    },
    "Energy & Power": {
        code: "energy_and_power",
        domains: {
            "Smart Energy & Others": "smart_energy",
            "Renewable Energy": "renewable_energy",
            "Utility & T&D": "utility_and_t_and_d",
            "Energy Storage": "energy_storage",
            "Nuclear Energy": "nuclear_energy",
            "Power Generation": "power_generation",
            "Hydrogen/Others": "hydrogen",
            "Oil & Gas": "oil_and_gas",
            "Mining & Metals": "mining_and_metals"
        }
    },
    "Food & Beverage": {
        code: "food_and_beverage",
        domains: {
            "Food Tech/Others": "food_tech",
            "Beverages": "beverages",
            "Food/Food Ingredients": "food_and_food_ingredients",
            "Nutraceuticals": "nutraceuticals",
            "Food & Beverage Services/Equipment": "food_and_beverage_services_and_equipment",
            "Health & Wellness": "health_and_wellness",
            "Dairy Products": "dairy_products",
            "Retails & Others": "retails"
        }
    },
    "Healthcare": {
        code: "healthcare",
        domains: {
            "Healthcare IT/Others": "healthcare_it",
            "Medical Devices": "medical_devices",
            "Pharmaceuticals": "pharmaceuticals",
            "Biotechnology": "biotechnology",
            "Diagnostics": "diagnostics",
            "Assisted Living": "assisted_living",
            "Therapeutics": "therapeutics",
            "Healthcare Services": "healthcare_services",
            "Animal Health": "animal_health"
        }
    },
    "Information & Communications Technology": {
        code: "information_and_communications_technology",
        domains: {
            "AI & Robotics/Others": "ai_and_robotics",
            "Cloud & Data Center": "cloud_and_data_center",
            "Enterprise/Consumer IT": "enterprise_consumer_it",
            "Emerging Tech": "emerging_tech",
            "Software & Services": "software_and_services",
            "Communication & Hardware": "communication_and_hardware",
            "Information & Cybersecurity": "information_and_cybersecurity",
            "Digitalization and IoT": "digitalization_and_iot"
        }
    },
    "Packaging, Construction, Mining & Gases": {
        code: "packaging_construction_mining_and_gases",
        domains: {
            "Construction & Manufacturing": "construction_and_manufacturing",
            "Equipment Machine & Tooling": "equipment_machine_and_tooling_p",
            "Mining Metals & Minerals": "mining_metals_and_minerals",
            "Packaging": "packaging",
            "Industrial Gases": "industrial_gases_p"
        }
    },
    "Retail & eCommerce": {
        code: "retail_and_ecommerce",
        domains: {
            "FMCG/Others": "fmcg",
            "Retail": "retail",
            "Consumer Electronics": "consumer_electronics",
            "Fashion & Apparel": "fashion_and_apparel",
            "eCommerce": "ecommerce",
            "Consumer Goods": "consumer_goods"
        }
    },
    "Semiconductor & Electronics": {
        code: "semiconductor_and_electronics",
        domains: {
            "Optoelectronics/Others": "optoelectronics",
            "Electronic Systems": "electronic_systems",
            "Semi Device/Materials": "semi_device_materials",
            "Electrical Systems & Converters": "electrical_systems_and_converters",
            "Sensors & Advanced Controls": "sensors_and_advanced_controls",
            "Displays": "displays"
        }
    }
};
